
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("63Bb0", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $7a2d214fe3e9c172$export$2e2bcd8739ae039);
$parcel$export(module.exports, "HistoryItemComponent", () => (parcelRequire("70ZWV")).default);
$parcel$export(module.exports, "HistoryItem", () => (parcelRequire("gbCtP")).default);
$parcel$export(module.exports, "useIssueHistoryUi", () => (parcelRequire("lPQOf")).useIssueHistoryUi);
$parcel$export(module.exports, "Change", () => (parcelRequire("l6g9G")).default);
$parcel$export(module.exports, "GroupedChange", () => (parcelRequire("fXrto")).default);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $kS4m4 = parcelRequire("kS4m4");

var $8Bhe1 = parcelRequire("8Bhe1");

var $70ZWV = parcelRequire("70ZWV");

var $gbCtP = parcelRequire("gbCtP");

var $lPQOf = parcelRequire("lPQOf");

var $l6g9G = parcelRequire("l6g9G");

var $fXrto = parcelRequire("fXrto");
const $7a2d214fe3e9c172$var$IssueHistoryContainer = ({ baseUrl: baseUrl, issueKey: issueKey, timeZone: timeZone, sortOrder: sortOrder, GroupedActivityEntryComponent: GroupedActivityEntryComponent, issueViewRelayFragment: issueViewRelayFragment })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "issue-history"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kS4m4.TimeZoneProvider), {
        value: timeZone
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8Bhe1.default), {
        baseUrl: baseUrl,
        issueKey: issueKey,
        sortOrder: sortOrder,
        GroupedActivityEntryComponent: GroupedActivityEntryComponent,
        issueViewRelayFragment: issueViewRelayFragment
    })));
var $7a2d214fe3e9c172$export$2e2bcd8739ae039 = $7a2d214fe3e9c172$var$IssueHistoryContainer;

});
parcelRegister("kS4m4", function(module, exports) {

$parcel$export(module.exports, "TimeZoneProvider", () => $9331888828e53240$export$da03264bca545d75);

var $5uXOq = parcelRequire("5uXOq");

var $9E5cm = parcelRequire("9E5cm");
const { Provider: $9331888828e53240$var$Provider, Consumer: $9331888828e53240$export$f45fbe45e97edb6f } = /*#__PURE__*/ (0, $5uXOq.createContext)((0, $9E5cm.SYDNEY_TIMEZONE));
const $9331888828e53240$export$da03264bca545d75 = (props)=>{
    const { children: children, value: value } = props;
    // Set default again if one attribute is undefined
    const memoizedValue = (0, $5uXOq.useMemo)(()=>value ?? (0, $9E5cm.getBrowserTimeZone)(), [
        value
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9331888828e53240$var$Provider, {
        value: memoizedValue
    }, children);
};

});

parcelRegister("8Bhe1", function(module, exports) {

$parcel$export(module.exports, "default", () => $a2abf8fa145bf89f$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $4R6GH = parcelRequire("4R6GH");

var $l8ruj = parcelRequire("l8ruj");

var $f222s = parcelRequire("f222s");

var $ldk2H = parcelRequire("ldk2H");

var $2gYDP = parcelRequire("2gYDP");

var $3AVPf = parcelRequire("3AVPf");

var $k1L82 = parcelRequire("k1L82");

var $3kIZW = parcelRequire("3kIZW");

var $ir3sd = parcelRequire("ir3sd");
const $a2abf8fa145bf89f$var$META_CONTAINER = 'META_CONTAINER';
const $a2abf8fa145bf89f$var$HistoryItemsDI = (0, $ir3sd.default);
const $a2abf8fa145bf89f$var$IssueHistory = ({ baseUrl: baseUrl, issueKey: issueKey, sortOrder: sortOrder, HistoryItems: HistoryItems, IssueHistoryService: IssueHistoryService, GroupedActivityEntryComponent: GroupedActivityEntryComponent, issueViewRelayFragment: issueViewRelayFragment })=>{
    const { userPreferredLayout: userPreferredLayout } = (0, $k1L82.useUserPreferredWorkItemLayout)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3AVPf.FeedContainer), {
        "data-testid": "issue-history.ui.feed-container"
    }, userPreferredLayout === 'WIDE' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a2abf8fa145bf89f$var$MetaDataWrapper, {
        "data-testid": "issue-history.ui.meta-data"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "issue-timestamps"
    }, (0, $4R6GH.fg)('relay-migration-issue-fields-metadata') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f222s.IssueViewMetaContainer), {
        key: $a2abf8fa145bf89f$var$META_CONTAINER,
        fragmentKey: issueViewRelayFragment ?? null
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ldk2H.default), {
        key: $a2abf8fa145bf89f$var$META_CONTAINER
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(IssueHistoryService, {
        baseUrl: baseUrl,
        issueKey: issueKey,
        sortOrder: sortOrder
    }, ({ loading: loading, loadingMore: loadingMore, hasMore: hasMore, loadMore: loadMore, error: error, data: data })=>{
        if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2gYDP.default), null);
        if (error) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(HistoryItems, {
            history: data,
            hasMore: hasMore,
            isLoadingMore: loadingMore,
            onLoadMore: loadMore,
            sortOrder: sortOrder,
            GroupedActivityEntryComponent: GroupedActivityEntryComponent
        });
    }));
};
$a2abf8fa145bf89f$var$IssueHistory.defaultProps = {
    HistoryItems: $a2abf8fa145bf89f$var$HistoryItemsDI,
    IssueHistoryService: (0, $3kIZW.default)
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a2abf8fa145bf89f$var$MetaDataWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1n261g80 _2lx2vrvc _4cvr1y6m _1bah1yb4 _ae4v1fhb _18u0xmi2 _otyr1ejb _19pkmgjw",
            __cmplp.className
        ])
    });
});
var $a2abf8fa145bf89f$export$2e2bcd8739ae039 = $a2abf8fa145bf89f$var$IssueHistory;

});
parcelRegister("f222s", function(module, exports) {

$parcel$export(module.exports, "IssueViewMetaContainer", () => $6486f244c2c8a9e6$export$dab313962088f323);

var $czcHh = parcelRequire("czcHh");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $6VZ0u = parcelRequire("6VZ0u");

var $hupju = parcelRequire("hupju");

var $fIzgc = parcelRequire("fIzgc");

var $cSD7y = parcelRequire("cSD7y");

var $k1L82 = parcelRequire("k1L82");
const $6486f244c2c8a9e6$var$IssueViewMetaContainerOld = ({ fragmentKey: fragmentKey })=>{
    const { userPreferredLayout: userPreferredLayout } = (0, $k1L82.useUserPreferredWorkItemLayout)();
    const data = (0, $8Uumt.useFragment)((0, $czcHh.default), fragmentKey);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $6486f244c2c8a9e6$var$containerStyles,
            userPreferredLayout === 'WIDE' && $6486f244c2c8a9e6$var$wideViewStyle
        ]
    }, data?.createdField && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6VZ0u.IssueViewCreatedDateField), {
        fragmentKey: data.createdField
    }), data?.updatedField && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fIzgc.IssueViewUpdatedDateField), {
        fragmentKey: data.updatedField
    }), data?.resolutionDateField && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hupju.IssueViewResolvedDateField), {
        fragmentKey: data.resolutionDateField
    }));
};
const $6486f244c2c8a9e6$var$IssueViewMetaContainerMemo = /*#__PURE__*/ (0, $5uXOq.memo)($6486f244c2c8a9e6$var$IssueViewMetaContainerOld);
const $6486f244c2c8a9e6$export$dab313962088f323 = (0, $cSD7y.componentWithFG)('issue_view_timestamp_perf', $6486f244c2c8a9e6$var$IssueViewMetaContainerMemo, $6486f244c2c8a9e6$var$IssueViewMetaContainerOld);
const $6486f244c2c8a9e6$var$containerStyles = (0, $8CUq3.xcss)({
    marginTop: 'space.050',
    marginRight: 'space.200',
    flex: 1,
    paddingLeft: 'space.150'
});
const $6486f244c2c8a9e6$var$wideViewStyle = (0, $8CUq3.xcss)({
    display: 'flex',
    gap: 'space.200'
});

});
parcelRegister("czcHh", function(module, exports) {

$parcel$export(module.exports, "default", () => $610f7c33bfe64b09$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f9e10ea1d8b74d589d9539a7dcda5814>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $610f7c33bfe64b09$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ui_issueViewLayoutMetaContainer_IssueViewMetaContainerOld",
    "selections": [
        {
            "concreteType": "JiraDateTimePickerField",
            "kind": "LinkedField",
            "name": "createdField",
            "plural": false,
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "ui_issueViewLayoutMetaCreatedDateField_IssueViewCreatedDateField"
                }
            ]
        },
        {
            "concreteType": "JiraDateTimePickerField",
            "kind": "LinkedField",
            "name": "updatedField",
            "plural": false,
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "ui_issueViewLayoutMetaUpdatedDateField_IssueViewUpdatedDateField"
                }
            ]
        },
        {
            "concreteType": "JiraDateTimePickerField",
            "kind": "LinkedField",
            "name": "resolutionDateField",
            "plural": false,
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "ui_issueViewLayoutMetaResolvedDateField_IssueViewResolvedDateField"
                }
            ]
        }
    ],
    "type": "JiraIssue"
};
$610f7c33bfe64b09$var$node.hash = "cfbc77a1aac5a54b7f7424cf9533c092";
var $610f7c33bfe64b09$export$2e2bcd8739ae039 = $610f7c33bfe64b09$var$node;

});

parcelRegister("6VZ0u", function(module, exports) {

$parcel$export(module.exports, "IssueViewCreatedDateField", () => $46dcf144014aca5f$export$48fee9c917da958a);

var $exjx4 = parcelRequire("exjx4");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $WDGDX = parcelRequire("WDGDX");
const $46dcf144014aca5f$export$48fee9c917da958a = ({ fragmentKey: fragmentKey })=>{
    const data = (0, $8Uumt.useFragment)((0, $exjx4.default), fragmentKey);
    if (!data.dateTime) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $WDGDX.CreatedDate), {
        date: data.dateTime
    });
};

});
parcelRegister("exjx4", function(module, exports) {

$parcel$export(module.exports, "default", () => $82a884d225c8231c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9e8462ff62978ed4316847e9c28e5565>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $82a884d225c8231c$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ui_issueViewLayoutMetaCreatedDateField_IssueViewCreatedDateField",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "dateTime"
        }
    ],
    "type": "JiraDateTimePickerField"
};
$82a884d225c8231c$var$node.hash = "7a873820e7f681cece55adec6c8641e3";
var $82a884d225c8231c$export$2e2bcd8739ae039 = $82a884d225c8231c$var$node;

});

parcelRegister("WDGDX", function(module, exports) {

$parcel$export(module.exports, "CreatedDate", () => $bbeac1d0e85fbf08$export$71ddacaac65a33a4);

var $5uXOq = parcelRequire("5uXOq");

var $i2Rm5 = parcelRequire("i2Rm5");

var $koVbs = parcelRequire("koVbs");

var $g12jx = parcelRequire("g12jx");


var $jjBa7 = parcelRequire("jjBa7");
const $bbeac1d0e85fbf08$export$71ddacaac65a33a4 = ({ date: date })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return date !== null && date !== '' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i2Rm5.ErrorBoundaryFlag), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g12jx.default), {
        testId: (0, $3148f3bcf8261dee$export$28db549dd85ab6df),
        date: date,
        text: formatMessage((0, $jjBa7.default).createdLabel)
    })) : null;
};

});
parcelRegister("g12jx", function(module, exports) {

$parcel$export(module.exports, "default", () => $da414731925bf8c1$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $47bDC = parcelRequire("47bDC");

var $kgoHi = parcelRequire("kgoHi");
var $8CUq3 = parcelRequire("8CUq3");

var $6ZEN7 = parcelRequire("6ZEN7");

var $cSD7y = parcelRequire("cSD7y");
const $da414731925bf8c1$var$MetaDateOld = (props)=>{
    const { text: text, date: date, testId: testId } = props;
    if (date === undefined || date === null) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        testId: testId,
        xcss: $da414731925bf8c1$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($da414731925bf8c1$var$TextSpan, null, text, "\xa0", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6ZEN7.default), {
        value: date,
        extraStyles: $da414731925bf8c1$export$cfbd42e6289bc323,
        tooltipPosition: "right"
    })));
};
const $da414731925bf8c1$var$MetaDateMemo = /*#__PURE__*/ (0, $5uXOq.memo)((props)=>{
    const { text: text, date: date, testId: testId } = props;
    if (date === undefined || date === null) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        testId: testId,
        xcss: $da414731925bf8c1$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($da414731925bf8c1$var$TextSpan, null, text, "\xa0", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6ZEN7.default), {
        value: date,
        extraStyles: $da414731925bf8c1$export$cfbd42e6289bc323,
        tooltipPosition: "right"
    })));
});
const $da414731925bf8c1$var$MetaDate = (0, $cSD7y.componentWithFG)('issue_view_timestamp_perf', $da414731925bf8c1$var$MetaDateMemo, $da414731925bf8c1$var$MetaDateOld);
var $da414731925bf8c1$export$2e2bcd8739ae039 = $da414731925bf8c1$var$MetaDate;
const $da414731925bf8c1$var$containerStyles = (0, $8CUq3.xcss)({
    marginTop: 'space.050'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $da414731925bf8c1$var$TextSpan = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "small", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c8dcr7 _syaz1gjq _ca0qv77o _o5721q9c _19pkidpf _vwz41clk",
            __cmplp.className
        ])
    });
});
$da414731925bf8c1$var$TextSpan.displayName = 'TextSpan'; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $da414731925bf8c1$export$cfbd42e6289bc323 = {
    whenDisplaySettingSwitchable: (0, $47bDC.css)({
        '&:hover': {
            color: "var(--ds-text-subtle, #44546F)"
        }
    })
};

});

const $3148f3bcf8261dee$export$28db549dd85ab6df = 'created-date.ui.read.meta-date';

parcelRegister("jjBa7", function(module, exports) {

$parcel$export(module.exports, "default", () => $546efa7d750d8970$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $546efa7d750d8970$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    createdLabel: {
        "id": "created-date.read.created-label",
        "defaultMessage": "Created"
    }
});

});



parcelRegister("hupju", function(module, exports) {

$parcel$export(module.exports, "IssueViewResolvedDateField", () => $f3bfaf749db1c266$export$21e5ab19e5b551d5);

var $33AFh = parcelRequire("33AFh");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $jz6ZE = parcelRequire("jz6ZE");
const $f3bfaf749db1c266$export$21e5ab19e5b551d5 = ({ fragmentKey: fragmentKey })=>{
    const data = (0, $8Uumt.useFragment)((0, $33AFh.default), fragmentKey);
    if (!data.dateTime) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jz6ZE.ResolvedDate), {
        date: data.dateTime
    });
};

});
parcelRegister("33AFh", function(module, exports) {

$parcel$export(module.exports, "default", () => $905e48afd806e4e6$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d77eb9fc84b20aecb90697ee7911ebab>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $905e48afd806e4e6$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ui_issueViewLayoutMetaResolvedDateField_IssueViewResolvedDateField",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "dateTime"
        }
    ],
    "type": "JiraDateTimePickerField"
};
$905e48afd806e4e6$var$node.hash = "6a930131aee2a1313fe4a8e084c7a7ab";
var $905e48afd806e4e6$export$2e2bcd8739ae039 = $905e48afd806e4e6$var$node;

});

parcelRegister("jz6ZE", function(module, exports) {

$parcel$export(module.exports, "ResolvedDate", () => $474fa1406add7c0a$export$a30ef0630a43e5ae);

var $5uXOq = parcelRequire("5uXOq");

var $i2Rm5 = parcelRequire("i2Rm5");

var $koVbs = parcelRequire("koVbs");

var $g12jx = parcelRequire("g12jx");


var $jqWOH = parcelRequire("jqWOH");
const $474fa1406add7c0a$export$a30ef0630a43e5ae = ({ date: date })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return date !== null && date !== '' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i2Rm5.ErrorBoundaryFlag), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g12jx.default), {
        testId: (0, $6a417f6e9f9304a7$export$8f2474d3634cae2f),
        date: date,
        text: formatMessage((0, $jqWOH.default).resolvedLabel)
    })) : null;
};

});
const $6a417f6e9f9304a7$export$8f2474d3634cae2f = 'resolved-date.ui.read.meta-date';

parcelRegister("jqWOH", function(module, exports) {

$parcel$export(module.exports, "default", () => $048b7348095633b0$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $048b7348095633b0$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    resolvedLabel: {
        "id": "resolved-date.read.resolved-label",
        "defaultMessage": "Resolved"
    }
});

});



parcelRegister("fIzgc", function(module, exports) {

$parcel$export(module.exports, "IssueViewUpdatedDateField", () => $a1494a814a82abf6$export$63d09e52cf6b72c3);

var $ewKSk = parcelRequire("ewKSk");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $8i6xC = parcelRequire("8i6xC");
const $a1494a814a82abf6$export$63d09e52cf6b72c3 = ({ fragmentKey: fragmentKey })=>{
    const data = (0, $8Uumt.useFragment)((0, $ewKSk.default), fragmentKey);
    if (!data.dateTime) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8i6xC.UpdatedDate), {
        date: data.dateTime
    });
};

});
parcelRegister("ewKSk", function(module, exports) {

$parcel$export(module.exports, "default", () => $630dc3f8317bfb47$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1fa60d0b1a3a8ed0caa871a0c71dbfdc>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $630dc3f8317bfb47$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ui_issueViewLayoutMetaUpdatedDateField_IssueViewUpdatedDateField",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "dateTime"
        }
    ],
    "type": "JiraDateTimePickerField"
};
$630dc3f8317bfb47$var$node.hash = "34f406f9cda9f12c9ce457379082edbd";
var $630dc3f8317bfb47$export$2e2bcd8739ae039 = $630dc3f8317bfb47$var$node;

});

parcelRegister("8i6xC", function(module, exports) {

$parcel$export(module.exports, "UpdatedDate", () => $140752db391fac59$export$b35f52e6703bf6e5);

var $5uXOq = parcelRequire("5uXOq");

var $i2Rm5 = parcelRequire("i2Rm5");

var $koVbs = parcelRequire("koVbs");

var $g12jx = parcelRequire("g12jx");


var $9Lm2x = parcelRequire("9Lm2x");
const $140752db391fac59$export$b35f52e6703bf6e5 = ({ date: date })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return date !== null && date !== '' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i2Rm5.ErrorBoundaryFlag), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g12jx.default), {
        testId: (0, $c7a34905366f2cf4$export$5af0222d5fa60156),
        date: date,
        text: formatMessage((0, $9Lm2x.default).updatedLabel)
    })) : null;
};

});
const $c7a34905366f2cf4$export$5af0222d5fa60156 = 'updated-date.ui.read.meta-date';

parcelRegister("9Lm2x", function(module, exports) {

$parcel$export(module.exports, "default", () => $51ba081614c27846$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $51ba081614c27846$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    updatedLabel: {
        "id": "updated-date.read.updated-label",
        "defaultMessage": "Updated"
    }
});

});




parcelRegister("ldk2H", function(module, exports) {

$parcel$export(module.exports, "default", () => $95a52ac68624d513$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $l3aF6 = parcelRequire("l3aF6");

var $2gCtH = parcelRequire("2gCtH");

var $c83pc = parcelRequire("c83pc");

var $1KWQw = parcelRequire("1KWQw");

var $k1L82 = parcelRequire("k1L82");
const $95a52ac68624d513$var$MetaContainerView = ()=>{
    const issueKey = (0, $2gCtH.useIssueKey)();
    const { isInWideLayoutExperiment: isInWideLayoutExperiment } = (0, $k1L82.useUserPreferredWorkItemLayout)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $95a52ac68624d513$var$containerStyle,
            isInWideLayoutExperiment && $95a52ac68624d513$var$wideViewStyle
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l3aF6.CreatedDateField), {
        issueKey: issueKey
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1KWQw.UpdatedDateField), {
        issueKey: issueKey
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c83pc.ResolvedDateField), {
        issueKey: issueKey
    }));
};
var $95a52ac68624d513$export$2e2bcd8739ae039 = $95a52ac68624d513$var$MetaContainerView;
const $95a52ac68624d513$var$containerStyle = (0, $8CUq3.xcss)({
    marginTop: 'space.050',
    marginRight: 'space.200',
    flex: 1,
    paddingLeft: 'space.150'
});
const $95a52ac68624d513$var$wideViewStyle = (0, $8CUq3.xcss)({
    display: 'flex',
    gap: 'space.200'
});

});
parcelRegister("l3aF6", function(module, exports) {

$parcel$export(module.exports, "CreatedDateField", () => $15e44c9b3d92701e$export$18b884e4285fe572);

var $5uXOq = parcelRequire("5uXOq");

var $bfjen = parcelRequire("bfjen");

var $WDGDX = parcelRequire("WDGDX");
const $15e44c9b3d92701e$export$18b884e4285fe572 = ({ issueKey: issueKey })=>{
    const [{ value: createdDate }] = (0, $bfjen.default)({
        issueKey: issueKey
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $WDGDX.CreatedDate), {
        date: createdDate
    });
};

});
parcelRegister("bfjen", function(module, exports) {

$parcel$export(module.exports, "default", () => $790f572429eef33c$export$2e2bcd8739ae039);

var $3fAi8 = parcelRequire("3fAi8");

var $5fc53 = parcelRequire("5fc53");
const $790f572429eef33c$var$useCreatedDateField = ({ issueKey: issueKey })=>{
    const [value] = (0, $3fAi8.useFieldValue)({
        issueKey: issueKey,
        fieldKey: (0, $5fc53.CREATED)
    });
    return [
        {
            value: value
        }
    ];
};
var $790f572429eef33c$export$2e2bcd8739ae039 = $790f572429eef33c$var$useCreatedDateField;

});


parcelRegister("c83pc", function(module, exports) {

$parcel$export(module.exports, "ResolvedDateField", () => $ae80e6a8f50685be$export$821b0e53537ab70d);

var $5uXOq = parcelRequire("5uXOq");

var $fHgll = parcelRequire("fHgll");

var $jz6ZE = parcelRequire("jz6ZE");
const $ae80e6a8f50685be$export$821b0e53537ab70d = ({ issueKey: issueKey })=>{
    const [{ value: resolvedDate }] = (0, $fHgll.default)({
        issueKey: issueKey
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jz6ZE.ResolvedDate), {
        date: resolvedDate
    });
};

});
parcelRegister("fHgll", function(module, exports) {

$parcel$export(module.exports, "default", () => $a6c0563b08e64303$export$2e2bcd8739ae039);

var $3fAi8 = parcelRequire("3fAi8");

var $5fc53 = parcelRequire("5fc53");
const $a6c0563b08e64303$var$useResolvedDateField = ({ issueKey: issueKey })=>{
    const [value] = (0, $3fAi8.useFieldValue)({
        issueKey: issueKey,
        fieldKey: (0, $5fc53.RESOLUTION_DATE)
    });
    return [
        {
            value: value
        }
    ];
};
var $a6c0563b08e64303$export$2e2bcd8739ae039 = $a6c0563b08e64303$var$useResolvedDateField;

});


parcelRegister("1KWQw", function(module, exports) {

$parcel$export(module.exports, "UpdatedDateField", () => $9be9a8ca7198025d$export$38578e62a97aeba2);

var $5uXOq = parcelRequire("5uXOq");

var $3zsox = parcelRequire("3zsox");

var $8i6xC = parcelRequire("8i6xC");
const $9be9a8ca7198025d$export$38578e62a97aeba2 = ({ issueKey: issueKey })=>{
    const [{ value: updatedDate }] = (0, $3zsox.default)({
        issueKey: issueKey
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8i6xC.UpdatedDate), {
        date: updatedDate
    });
};

});
parcelRegister("3zsox", function(module, exports) {

$parcel$export(module.exports, "default", () => $d06357cf215fc920$export$2e2bcd8739ae039);

var $3fAi8 = parcelRequire("3fAi8");

var $5fc53 = parcelRequire("5fc53");
const $d06357cf215fc920$var$useUpdatedDateField = ({ issueKey: issueKey })=>{
    const [value] = (0, $3fAi8.useFieldValue)({
        issueKey: issueKey,
        fieldKey: (0, $5fc53.UPDATED)
    });
    return [
        {
            value: value
        }
    ];
};
var $d06357cf215fc920$export$2e2bcd8739ae039 = $d06357cf215fc920$var$useUpdatedDateField;

});



parcelRegister("2gYDP", function(module, exports) {

$parcel$export(module.exports, "default", () => $02f68cee092775a3$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $fNobW = parcelRequire("fNobW");

var $gwIPs = parcelRequire("gwIPs");

var $2gCtH = parcelRequire("2gCtH");

var $5EE09 = parcelRequire("5EE09");

var $inHmP = parcelRequire("inHmP");

var $gziy2 = parcelRequire("gziy2");

var $gbG9h = parcelRequire("gbG9h");

var $jwwuI = parcelRequire("jwwuI");

var $2e4p8 = parcelRequire("2e4p8");
const $02f68cee092775a3$var$activityItemSkeleton = (isModal)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($02f68cee092775a3$var$AvatarWrapper, {
        isModal: isModal
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5EE09.default), {
        isModal: isModal
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($02f68cee092775a3$var$Divider, {
        isModal: isModal
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $inHmP.default), {
        isModal: isModal,
        paddingTop: 0,
        paddingBottom: 0
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $inHmP.default), {
        isModal: isModal,
        paddingTop: 1,
        paddingBottom: 5
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jwwuI.default), {
        isModal: isModal,
        fontSize: 14,
        lineHeight: 16,
        intrusion: 250
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $inHmP.default), {
        isModal: isModal,
        paddingTop: 4,
        paddingBottom: 0
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jwwuI.default), {
        isModal: isModal,
        fontSize: 24,
        lineHeight: 24,
        intrusion: 0
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($02f68cee092775a3$var$FillerMask, {
        isModal: isModal
    })));
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$02f68cee092775a3$export$2e2bcd8739ae039 = ()=>{
    const isModal = (0, $2gCtH.useIsModal)();
    const isEmbedMode = (0, $2e4p8.useIsEmbedMode)();
    const isLayered = isModal || isEmbedMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fNobW.default), {
        name: "activity-feed-skeleton"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($02f68cee092775a3$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gziy2.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($02f68cee092775a3$var$FormContainer, {
        isModal: isLayered,
        paddingTop: 0,
        paddingBottom: 0
    }, $02f68cee092775a3$var$activityItemSkeleton(isLayered)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($02f68cee092775a3$var$FormContainer, {
        isModal: isLayered,
        paddingTop: 0,
        paddingBottom: 0
    }, $02f68cee092775a3$var$activityItemSkeleton(isLayered))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $02f68cee092775a3$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $gbG9h.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2lx21bp4 _1bsb1osq",
            __cmplp.className
        ])
    });
});
const $02f68cee092775a3$var$FormContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $inHmP.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
});
const $02f68cee092775a3$var$Divider = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $gziy2.CleanDiv), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsbrdoj _1o9zidpf",
            __cmplp.className
        ])
    });
});
const $02f68cee092775a3$var$FillerMask = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $gziy2.CleanDiv), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3iqslr",
            __cmplp.className
        ])
    });
});
const $02f68cee092775a3$var$AvatarWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isModal: isModal, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1hkv1pv": (0, $lD23V.default)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            `${(0, $gwIPs.gridSize) * 4}px solid ${__cmplp.isModal ? "var(--ds-surface-overlay, #FFFFFF)" : "var(--ds-surface, #FFFFFF)"}`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_n7zl1u5a _4t3i1ylp _1o9zidpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("5EE09", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3d42d3ac874373a$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
const $b3d42d3ac874373a$var$Avatar = ({ isModal: isModal })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("mask", {
        id: "circle-cutout"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
        x: "0",
        y: "0",
        width: "40",
        height: "40",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("circle", {
        cx: "18",
        cy: "18",
        r: "16",
        fill: "black"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
        x: "0",
        y: "0",
        width: "40",
        height: "40",
        mask: "url(#circle-cutout)",
        fill: isModal ? "var(--ds-surface-overlay, #FFFFFF)" : "var(--ds-surface, #FFFFFF)"
    }));
var $b3d42d3ac874373a$export$2e2bcd8739ae039 = $b3d42d3ac874373a$var$Avatar;

});

parcelRegister("inHmP", function(module, exports) {

$parcel$export(module.exports, "default", () => $54bbb06281f009d3$export$2e2bcd8739ae039);
/* container-mask-view.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");
const $54bbb06281f009d3$var$SC1 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isModal: isModal, paddingTop: paddingTop, paddingBottom: paddingBottom, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1cgzp5c": (0, $lD23V.default)(__cmplp.paddingTop, "px"),
            "--_1ntldin": (0, $lD23V.default)(__cmplp.paddingBottom, "px")
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _1bsb1osq",
            __cmplp.isModal ? "_x3doostm" : "_x3do3rsf",
            __cmplp.isModal ? "_n7zlfiih" : "_n7zlh1it",
            __cmplp.className
        ])
    });
});
var $54bbb06281f009d3$export$2e2bcd8739ae039 = $54bbb06281f009d3$var$SC1;

});

parcelRegister("gziy2", function(module, exports) {

$parcel$export(module.exports, "CleanDiv", () => $48343d4de2fdf814$export$e2099645cdcaf24c);
$parcel$export(module.exports, "default", () => $48343d4de2fdf814$export$2e2bcd8739ae039);
/* skeleton-background-view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $48343d4de2fdf814$var$shimmer = null;
const $48343d4de2fdf814$export$e2099645cdcaf24c = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isModal: isModal, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1itkglyw",
            __cmplp.isModal ? "_bfhk1bhr" : "_bfhkvuon",
            __cmplp.className
        ])
    });
});
const $48343d4de2fdf814$var$SC1 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_5sag9cwz _1o51q7pw _tip812c5 _j7hq1nls _1pglp3kn _bfhkm7j4 _1itki374 _12vemgnk _kqswstnw _1ltvidpf _1xi2idpf _154iidpf _94n5idpf",
            __cmplp.className
        ])
    });
});
var $48343d4de2fdf814$export$2e2bcd8739ae039 = $48343d4de2fdf814$var$SC1;

});

parcelRegister("gbG9h", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6d1702b4b053523$export$2e2bcd8739ae039);
/* skeleton-container-view.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $c6d1702b4b053523$var$SC1 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1osq _1e0c1txw _kqswh2mm",
            __cmplp.className
        ])
    });
});
var $c6d1702b4b053523$export$2e2bcd8739ae039 = $c6d1702b4b053523$var$SC1;

});

parcelRegister("jwwuI", function(module, exports) {

$parcel$export(module.exports, "default", () => $c1f6fc2abf0e090a$export$2e2bcd8739ae039);
/* text-line-mask-view.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");
const $c1f6fc2abf0e090a$var$SC1 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isModal: isModal, intrusion: intrusion, lineHeight: lineHeight, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1sswcfi": (0, $lD23V.default)(`${__cmplp.fontSize}px`),
            "--_172l934": (0, $lD23V.default)(__cmplp.intrusion, "px"),
            "--_1o6j0d": (0, $lD23V.default)((__cmplp.lineHeight - __cmplp.fontSize) / 2, "px")
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _4t3i1l57",
            __cmplp.isModal ? "_1s7z12nn" : "_1s7z1cpt",
            __cmplp.isModal ? "_x3do12pv" : "_x3do16rq",
            __cmplp.isModal ? "_n7zl12pv" : "_n7zl16rq",
            __cmplp.className
        ])
    });
});
var $c1f6fc2abf0e090a$export$2e2bcd8739ae039 = $c1f6fc2abf0e090a$var$SC1;

});


parcelRegister("3kIZW", function(module, exports) {

$parcel$export(module.exports, "default", () => $30ce151a22d6ac60$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $2YZCu = parcelRequire("2YZCu");

var $6s1D9 = parcelRequire("6s1D9");

var $lY0Md = parcelRequire("lY0Md");

var $ncRIe = parcelRequire("ncRIe");

var $93Yeu = parcelRequire("93Yeu");

var $hTZVr = parcelRequire("hTZVr");

var $bm1Wv = parcelRequire("bm1Wv");
const $30ce151a22d6ac60$export$53ac33307b5acee9 = (issueKey)=>({
        status: 'IDLE',
        issueKey: issueKey,
        historyItems: [],
        nextPageStartIndex: 0
    });
const $30ce151a22d6ac60$export$1650419e431d3ba3 = (state, action)=>{
    switch(action.type){
        case 'FETCH_PAGE_SUCCESS':
            // Result is stale if issue key changed in the meantime.
            if (action.issueKey !== state.issueKey) return state;
            return {
                ...state,
                status: 'IDLE',
                nextPageStartIndex: action.response.isLastPage ? null : action.response.nextPageStartIndex,
                historyItems: [
                    ...state.historyItems,
                    ...action.response.history
                ]
            };
        case 'FETCH_PAGE_FAILURE':
            // Result is stale if issue key changed in the meantime.
            if (action.issueKey !== state.issueKey) return state;
            return {
                ...state,
                status: 'ERROR'
            };
        case 'NEXT_PAGE_REQUESTED':
            return {
                ...state,
                status: 'LOADING_SUBSEQUENT_PAGE'
            };
        case 'CHANGE_ISSUE_REQUESTED':
            return {
                issueKey: action.issueKey,
                status: 'LOADING_FIRST_PAGE',
                historyItems: [],
                nextPageStartIndex: 0
            };
        default:
            // prettier-ignore
            // @ts-expect-error - TS2339 - Property 'type' does not exist on type 'never'.
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            action.type;
            // @ts-expect-error - TS2339 - Property 'type' does not exist on type 'never'.
            throw new Error(`Unknown action type in issue history reducer: ${action.type}`);
    }
};
const $30ce151a22d6ac60$export$3343632372cec89d = (baseUrl, issueKey, sortOrder)=>{
    const [state, dispatch] = (0, $5uXOq.useReducer)($30ce151a22d6ac60$export$1650419e431d3ba3, $30ce151a22d6ac60$export$53ac33307b5acee9(issueKey));
    const projectKey = (0, $93Yeu.useProjectKey)(issueKey);
    const projectType = (0, $93Yeu.useProjectType)(projectKey);
    const fetchPage = (0, $5uXOq.useCallback)(async (pageStartIndex, pageSize)=>{
        try {
            const response = await (0, $hTZVr.getIssueHistory)(baseUrl, issueKey, pageStartIndex, sortOrder, pageSize);
            (0, $6s1D9.sendExperienceAnalytics)({
                getExperienceDescription: ({ wasSuccessful: wasSuccessful })=>(0, $ncRIe.experienceDescription)({
                        experience: 'issueHistory',
                        action: 'FETCH_PAGE',
                        analyticsSource: 'issueHistoryFetch',
                        wasSuccessful: wasSuccessful,
                        projectType: projectType
                    })
            });
            dispatch({
                type: 'FETCH_PAGE_SUCCESS',
                response: response,
                issueKey: issueKey
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $2YZCu.default).safeErrorWithoutCustomerData('issue.activity.history.fetch-history-page', 'Query returned errors', error);
            (0, $6s1D9.sendExperienceAnalytics)({
                getExperienceDescription: ({ wasSuccessful: wasSuccessful, statusCode: statusCode })=>(0, $ncRIe.experienceDescription)({
                        experience: 'issueHistory',
                        action: 'FETCH_PAGE',
                        analyticsSource: 'issueHistoryFetch',
                        wasSuccessful: wasSuccessful,
                        projectType: projectType,
                        statusCode: statusCode,
                        errorMessage: error?.message || 'UNKNOWN_ERROR',
                        traceId: error?.traceId || ''
                    }),
                error: error
            });
            dispatch({
                type: 'FETCH_PAGE_FAILURE',
                issueKey: issueKey
            });
        }
    }, [
        baseUrl,
        issueKey,
        sortOrder,
        projectType
    ]);
    (0, $5uXOq.useEffect)(()=>{
        dispatch({
            type: 'CHANGE_ISSUE_REQUESTED',
            issueKey: issueKey
        });
        fetchPage(0, (0, $lY0Md.NUM_INITIAL_ITEMS_TO_LOAD_FOR_POST_LOAD_ACTIONS));
    }, [
        fetchPage,
        issueKey
    ]);
    const loadMore = ()=>{
        const { status: status, nextPageStartIndex: nextPageStartIndex } = state;
        if (status === 'IDLE' && nextPageStartIndex !== null) {
            dispatch({
                type: 'NEXT_PAGE_REQUESTED'
            });
            fetchPage(nextPageStartIndex, (0, $lY0Md.NUM_PAGED_ITEMS_TO_LOAD));
        }
    };
    const { status: status, historyItems: historyItems, nextPageStartIndex: nextPageStartIndex } = state;
    return {
        loading: status === 'LOADING_FIRST_PAGE',
        loadingMore: status === 'LOADING_SUBSEQUENT_PAGE',
        error: status === 'ERROR',
        hasMore: nextPageStartIndex !== null,
        data: (0, $bm1Wv.groupHistoryItems)(historyItems),
        loadMore: loadMore
    };
};
const $30ce151a22d6ac60$var$IssueHistoryService = ({ baseUrl: baseUrl, issueKey: issueKey, sortOrder: sortOrder, children: children })=>children($30ce151a22d6ac60$export$3343632372cec89d(baseUrl, issueKey, sortOrder));
var $30ce151a22d6ac60$export$2e2bcd8739ae039 = $30ce151a22d6ac60$var$IssueHistoryService;

});
parcelRegister("6s1D9", function(module, exports) {

$parcel$export(module.exports, "sendExperienceAnalytics", () => $ea62fd53ca447690$export$4a95ada1b8228562);



var $fZneA = parcelRequire("fZneA");

var $4R6GH = parcelRequire("4R6GH");

var $gXz4p = parcelRequire("gXz4p");
const $ea62fd53ca447690$var$successfulErrorStatusCodes = [
    (0, $3cd8a0ece36fbae5$export$9de493bcd9b1d977),
    (0, $3cd8a0ece36fbae5$export$67d19e9a991baa07),
    (0, $3cd8a0ece36fbae5$export$8bca792d963eb0ef)
];
const $ea62fd53ca447690$var$abortableStatusCodes = [
    (0, $3cd8a0ece36fbae5$export$6763168a631449a2)
];
const $ea62fd53ca447690$var$classificationPayload = {
    ANALYTICS_SUCCESS: {
        wasSuccessful: true,
        action: (0, $c0ec49ac5a1e4009$export$627ef4c1ed2d7a9a)
    },
    ANALYTICS_ABORT: {
        wasSuccessful: true,
        action: (0, $c0ec49ac5a1e4009$export$aeeb00d0845d24d8)
    },
    ANALYTICS_FAIL: {
        wasSuccessful: false,
        action: (0, $c0ec49ac5a1e4009$export$b48b3d1872522384)
    }
};
const $ea62fd53ca447690$var$isErrorOmitted = (error)=>error === null;
const $ea62fd53ca447690$var$isStatusCodeConsideredSuccessful = (error)=>// @ts-expect-error - TS2345 - Argument of type 'number | undefined' is not assignable to parameter of type 'number'.
    $ea62fd53ca447690$var$successfulErrorStatusCodes.includes(error?.statusCode);
const $ea62fd53ca447690$var$isStatusCodeAbortable = (error)=>// @ts-expect-error - TS2345 - Argument of type 'number | undefined' is not assignable to parameter of type 'number'.
    $ea62fd53ca447690$var$abortableStatusCodes.includes(error?.statusCode);
const $ea62fd53ca447690$var$reduceClassificationOld = (error)=>{
    if ($ea62fd53ca447690$var$isErrorOmitted(error) || $ea62fd53ca447690$var$isStatusCodeConsideredSuccessful(error)) return 'ANALYTICS_SUCCESS';
    if ($ea62fd53ca447690$var$isStatusCodeAbortable(error)) return 'ANALYTICS_ABORT';
    return 'ANALYTICS_FAIL';
};
const $ea62fd53ca447690$var$reduceClassificationNew = (error)=>{
    if ($ea62fd53ca447690$var$isErrorOmitted(error)) return 'ANALYTICS_SUCCESS';
    return 'ANALYTICS_FAIL';
};
const $ea62fd53ca447690$var$getReduceClassification = ()=>(0, $4R6GH.fg)('bento_send_4xx_to_task_fail_gate_1') ? $ea62fd53ca447690$var$reduceClassificationNew : $ea62fd53ca447690$var$reduceClassificationOld;
const $ea62fd53ca447690$export$4a95ada1b8228562 = ({ getExperienceDescription: getExperienceDescription, error: error = null })=>{
    // We intentionally do not capture analytics during a client a fetch error. However, we do
    // return the successful state so external flows can record logs
    if (!$ea62fd53ca447690$var$isErrorOmitted(error) && (0, $fZneA.isClientFetchError)(error) && !(0, $4R6GH.fg)('bento_send_4xx_to_task_fail_gate_1')) {
        getExperienceDescription({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            wasSuccessful: $ea62fd53ca447690$var$isErrorOmitted(error),
            statusCode: error?.statusCode
        });
        return;
    }
    const reduceClassification = $ea62fd53ca447690$var$getReduceClassification();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const classification = reduceClassification(error);
    const { action: action, wasSuccessful: wasSuccessful } = $ea62fd53ca447690$var$classificationPayload[classification];
    (0, $gXz4p.sendExperienceAnalytics)({
        ...getExperienceDescription({
            wasSuccessful: wasSuccessful,
            statusCode: error?.statusCode
        }),
        action: action
    });
};

});
const $3cd8a0ece36fbae5$export$ff39ebd4bb12b718 = 201;
const $3cd8a0ece36fbae5$export$3288b14b6745c572 = 204;
const $3cd8a0ece36fbae5$export$9de493bcd9b1d977 = 400;
const $3cd8a0ece36fbae5$export$67d19e9a991baa07 = 401;
const $3cd8a0ece36fbae5$export$a3269a3914b007e3 = 403;
const $3cd8a0ece36fbae5$export$8bca792d963eb0ef = 404;
const $3cd8a0ece36fbae5$export$4a3cb39801694eee = 407;
const $3cd8a0ece36fbae5$export$fa405bbf47d510e2 = 408;
const $3cd8a0ece36fbae5$export$c09e7ea0fc79f34f = 409;
const $3cd8a0ece36fbae5$export$5244030134e99 = 412;
const $3cd8a0ece36fbae5$export$f90ac1df0b60853d = 413;
const $3cd8a0ece36fbae5$export$a447d0a965e16776 = 422;
const $3cd8a0ece36fbae5$export$3b48aba8957000cd = 426;
const $3cd8a0ece36fbae5$export$6763168a631449a2 = 429;
const $3cd8a0ece36fbae5$export$e813cd7045fcc98d = 500;
const $3cd8a0ece36fbae5$export$2ce38d41a306034e = 502;
const $3cd8a0ece36fbae5$export$974c37534b0191b1 = 503;
const $3cd8a0ece36fbae5$export$5400e8dddac3fcf3 = 504;

const $c0ec49ac5a1e4009$export$627ef4c1ed2d7a9a = 'taskSuccess';
const $c0ec49ac5a1e4009$export$b48b3d1872522384 = 'taskFail';
const $c0ec49ac5a1e4009$export$aeeb00d0845d24d8 = 'taskAbort';


parcelRegister("lY0Md", function(module, exports) {

$parcel$export(module.exports, "NUM_INITIAL_ITEMS_TO_LOAD", () => $7ea3327a339880dd$export$724fbfb10c203824);
$parcel$export(module.exports, "NUM_INITIAL_ITEMS_TO_LOAD_FOR_POST_LOAD_ACTIONS", () => $7ea3327a339880dd$export$a1162d3036fadf0e);
$parcel$export(module.exports, "NUM_PAGED_ITEMS_TO_LOAD", () => $7ea3327a339880dd$export$ed7e687bbd42b4a7);
$parcel$export(module.exports, "NUM_PAGED_ITEMS_TO_LOAD_OLD", () => $7ea3327a339880dd$export$9b2f842ae6d3541d);
$parcel$export(module.exports, "LOAD_NEWER_BUTTON", () => $7ea3327a339880dd$export$4f2e52b6b9be5088);
$parcel$export(module.exports, "LOAD_OLDER_BUTTON", () => $7ea3327a339880dd$export$ed33f944ab1a1bb0);

var $gwIPs = parcelRequire("gwIPs");
const $7ea3327a339880dd$export$724fbfb10c203824 = 5;
const $7ea3327a339880dd$export$a1162d3036fadf0e = 100;
const $7ea3327a339880dd$export$ed7e687bbd42b4a7 = 100;
const $7ea3327a339880dd$export$9b2f842ae6d3541d = 10;
const $7ea3327a339880dd$export$ef42ae71539e03a7 = `${3 * (0, $gwIPs.gridSize)}px`;
const $7ea3327a339880dd$export$4f2e52b6b9be5088 = 'LOAD_NEWER_BUTTON';
const $7ea3327a339880dd$export$ed33f944ab1a1bb0 = 'LOAD_OLDER_BUTTON';

});

parcelRegister("ncRIe", function(module, exports) {

$parcel$export(module.exports, "experienceDescription", () => $a1b2d3b60638d00f$export$b80ef1f910664ac4);

var $4Pf62 = parcelRequire("4Pf62");

var $efvDm = parcelRequire("efvDm");

var $ldyPw = parcelRequire("ldyPw");
const $a1b2d3b60638d00f$export$b80ef1f910664ac4 = ({ experience: experience, wasSuccessful: wasSuccessful, action: action, analyticsSource: analyticsSource, projectType: projectType, errorMessage: errorMessage, statusCode: statusCode, isEventOccurredAtSelected: isEventOccurredAtSelected, traceId: traceId })=>{
    let application = null;
    let edition = null;
    if (projectType !== undefined) try {
        const { appEditions: appEditions } = (0, $4Pf62.getTenantContext_DEPRECATED_DO_NOT_USE)();
        application = (0, $efvDm.getApplicationForProject)(projectType);
        edition = (0, $ldyPw.getEdition)(application, appEditions);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
    // application and edition already default to null.
    }
    return {
        experience: experience,
        wasExperienceSuccesful: wasSuccessful,
        analyticsSource: analyticsSource,
        application: application,
        edition: edition,
        additionalAttributes: {
            action: action,
            ...typeof statusCode !== 'undefined' ? {
                statusCode: statusCode
            } : null,
            ...errorMessage !== undefined ? {
                errorMessage: errorMessage
            } : null,
            ...isEventOccurredAtSelected !== undefined ? {
                isEventOccurredAtSelected: isEventOccurredAtSelected
            } : null,
            ...traceId !== undefined ? {
                traceId: traceId
            } : null
        }
    };
};

});

parcelRegister("hTZVr", function(module, exports) {

$parcel$export(module.exports, "fetchIssueCreatedInfo", () => $e2b7d2a783aeaaf3$export$b071d2800a3c3856);
$parcel$export(module.exports, "getIssueHistory", () => $e2b7d2a783aeaaf3$export$efacec3410a85dc7);

var $eusud = parcelRequire("eusud");

var $iBOrg = parcelRequire("iBOrg");


var $eIYC1 = parcelRequire("eIYC1");
const $e2b7d2a783aeaaf3$export$d245426099cf4980 = `
    query IssueHistoryQuery($issueKey: String!, $startAt: Long, $maxResults: Int, $orderBy: String) {
        viewIssue(issueKey: $issueKey) {
            history(orderBy: $orderBy, startAt: $startAt, maxResults: $maxResults) {
                isLast
                totalCount
                startIndex
                nodes {
                    fieldId
                    fieldType
                    fieldSchema {
                        type
                        customFieldType
                    }
                    timestamp
                    actor {
                        avatarUrls {
                            large
                        }
                        displayName
                        accountId
                    }
                    fieldDisplayName
                    isDueToRedaction
                    from {
                        ... on GenericFieldValue {
                            displayValue
                            value
                        }
                        ... on AssigneeFieldValue {
                            displayValue
                            value
                            avatarUrl
                        }
                        ... on PriorityFieldValue {
                            displayValue
                            value
                            iconUrl
                        }
                        ... on StatusFieldValue {
                            displayValue
                            value
                            categoryId
                        }
                        ... on WorkLogFieldValue {
                            displayValue
                            value
                            worklog {
                                id
                                timeSpent
                            }
                        }
                        ... on RespondersFieldValue {
                            displayValue
                            value
                            responders {
                                ari
                                name
                                type
                                avatarUrl
                            }
                        }
                    }
                    to {
                        ... on GenericFieldValue {
                            displayValue
                            value
                        }
                        ... on AssigneeFieldValue {
                            displayValue
                            value
                            avatarUrl
                        }
                        ... on PriorityFieldValue {
                            displayValue
                            value
                            iconUrl
                        }
                        ... on StatusFieldValue {
                            displayValue
                            value
                            categoryId
                        }
                        ... on WorkLogFieldValue {
                            displayValue
                            value
                            worklog {
                                id
                                timeSpent
                            }
                        }
                        ... on RespondersFieldValue {
                            displayValue
                            value
                            responders {
                                ari
                                name
                                type
                                avatarUrl
                            }
                        }
                    }
                }
            }
        }
    }
`;
const $e2b7d2a783aeaaf3$var$getIssueCreatedUrl = (baseUrl, issueKey)=>`/rest/api/3/issue/${issueKey}?fields=creator,created`;
const $e2b7d2a783aeaaf3$export$b071d2800a3c3856 = (baseUrl, issueKey)=>(0, $eusud.performGetRequest)($e2b7d2a783aeaaf3$var$getIssueCreatedUrl(baseUrl, issueKey)).then((0, $eIYC1.transformCreateInfoResponse));
const $e2b7d2a783aeaaf3$export$23a326979994188b = async (baseUrl, issueKey, startAt, sortMode, pageSize)=>{
    const client = (0, $iBOrg.getClient)(baseUrl);
    // @ts-expect-error - Property 'data' does not exist on type 'unknown'. | Property 'errors' does not exist on type 'unknown'.
    const { data: data, errors: errors } = await client.query({
        query: $e2b7d2a783aeaaf3$export$d245426099cf4980,
        variables: {
            issueKey: issueKey,
            startAt: startAt,
            maxResults: pageSize,
            orderBy: sortMode === (0, $c97bf8752afb1bcb$export$e86669f498228fff) ? 'created' : '-created'
        }
    });
    if (errors) throw new Error(`Errors returned from IssueHistoryQuery result: ${errors// @ts-expect-error - TS7006 - Parameter 'x' implicitly has an 'any' type.
    .map((x)=>x.message).join(', ')}`);
    if (!data) throw new Error('Unexpected empty data object received from IssueHistoryQuery result with no errors');
    return (0, $eIYC1.transformGraphQlResponse)(data, pageSize);
};
const $e2b7d2a783aeaaf3$export$efacec3410a85dc7 = async (baseUrl, issueKey, startAt, sortMode, pageSize)=>{
    if (startAt === 0 && sortMode === (0, $c97bf8752afb1bcb$export$e86669f498228fff)) {
        const [issueHistory, createInfo] = await Promise.all([
            $e2b7d2a783aeaaf3$export$23a326979994188b(baseUrl, issueKey, startAt, sortMode, pageSize),
            $e2b7d2a783aeaaf3$export$b071d2800a3c3856(baseUrl, issueKey)
        ]);
        return {
            ...issueHistory,
            history: [
                createInfo,
                ...issueHistory.history
            ]
        };
    }
    const issueHistory = await $e2b7d2a783aeaaf3$export$23a326979994188b(baseUrl, issueKey, startAt, sortMode, pageSize);
    if (sortMode === (0, $c97bf8752afb1bcb$export$eda5fe8da1abb04c) && issueHistory.isLastPage) {
        const createInfo = await $e2b7d2a783aeaaf3$export$b071d2800a3c3856(baseUrl, issueKey);
        return {
            ...issueHistory,
            history: [
                ...issueHistory.history,
                createInfo
            ]
        };
    }
    return issueHistory;
};

});
// Activity sort order
const $c97bf8752afb1bcb$export$eda5fe8da1abb04c = 'NEWEST_FIRST';
const $c97bf8752afb1bcb$export$e86669f498228fff = 'OLDEST_FIRST';

parcelRegister("eIYC1", function(module, exports) {

$parcel$export(module.exports, "transformChangelogItem", () => $0f834988b4ac0bcf$export$a32d3e40a269588f);
$parcel$export(module.exports, "transformCreateInfoResponse", () => $0f834988b4ac0bcf$export$5135eb3afa736a29);
$parcel$export(module.exports, "transformGraphQlResponse", () => $0f834988b4ac0bcf$export$716425a07890b235);

var $gccSB = parcelRequire("gccSB");

var $eZDAP = parcelRequire("eZDAP");

var $el0er = parcelRequire("el0er");

var $gULOk = parcelRequire("gULOk");

var $6s1PB = parcelRequire("6s1PB");

var $5fc53 = parcelRequire("5fc53");

var $4R6GH = parcelRequire("4R6GH");

const $0f834988b4ac0bcf$var$transformRestActor = (actor)=>actor ? {
        avatarUrl: actor.avatarUrls['48x48'],
        displayName: actor.displayName,
        accountId: actor.accountId
    } : null;
const $0f834988b4ac0bcf$var$transformGraphQlActor = (actor)=>actor ? {
        avatarUrl: actor.avatarUrls.large,
        displayName: actor.displayName,
        accountId: actor.accountId
    } : null;
const $0f834988b4ac0bcf$export$a32d3e40a269588f = (item)=>{
    const { fieldSchema: fieldSchema, fieldId: fieldId, fieldType: fieldType, fieldDisplayName: fieldDisplayName, timestamp: changelogTimestamp, actor: changelogActor, isDueToRedaction: isDueToRedaction } = item;
    // so we don't need `if (from)...` on every branch
    let { from: from, to: to } = item;
    // @ts-expect-error - TS2322 - Type 'FieldValueGraphQlResponse | {}' is not assignable to type 'FieldValueGraphQlResponse | null | undefined'.
    from = from || {};
    // @ts-expect-error - TS2322 - Type 'FieldValueGraphQlResponse | {}' is not assignable to type 'FieldValueGraphQlResponse | undefined'.
    to = to || {};
    const actor = $0f834988b4ac0bcf$var$transformGraphQlActor(changelogActor);
    const timestamp = typeof changelogTimestamp === 'string' ? (0, $eZDAP.default)(changelogTimestamp) : (0, $el0er.default)(changelogTimestamp);
    if (isDueToRedaction && (0, $4R6GH.fg)('enable_redaction_support_in_jira_issue_view')) return {
        fieldType: (0, $6s1PB.expVal)('issue_view_activity_timeline', 'isActivityTimelineEnabled', false) ? fieldType : undefined,
        type: (0, $905bb3e9efa8fc48$export$53027079dd8d1476),
        actor: actor,
        timestamp: timestamp,
        field: fieldDisplayName
    };
    if ((fieldType === 'jira' && fieldId === 'description' || fieldType === 'custom' && fieldSchema?.customFieldType === (0, $5fc53.TEXT_AREA_CF_TYPE)) && (0, $6s1PB.expVal)('issue_view_activity_timeline', 'isActivityTimelineEnabled', false)) return {
        fieldType: fieldType,
        type: (0, $905bb3e9efa8fc48$export$771d231cdd66c0e2),
        actor: actor,
        timestamp: timestamp,
        field: fieldDisplayName,
        // @ts-expect-error - TS2533 - Object is possibly 'null' or 'undefined'.
        fromValue: from?.displayValue,
        // @ts-expect-error - TS2533 - Object is possibly 'null' or 'undefined'.
        toValue: to?.displayValue
    };
    if (fieldType === 'jira' && fieldId === 'assignee') return {
        fieldType: (0, $6s1PB.expVal)('issue_view_activity_timeline', 'isActivityTimelineEnabled', false) ? fieldType : undefined,
        type: (0, $905bb3e9efa8fc48$export$f1970b3f16b29de5),
        actor: actor,
        timestamp: timestamp,
        // @ts-expect-error - TS2322 - Type '{ displayName: string | null; avatarUrl: string | undefined; accountId: string | undefined; } | null' is not assignable to type 'User | null'. | TS2533 - Object is possibly 'null' or 'undefined'.
        fromUser: !(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(from.displayValue) ? {
            // @ts-expect-error - TS2533 - Object is possibly 'null' or 'undefined'.
            displayName: from.displayValue,
            // @ts-expect-error - TS2533 - Object is possibly 'null' or 'undefined'.
            avatarUrl: from.avatarUrl,
            // @ts-expect-error - TS2533 - Object is possibly 'null' or 'undefined'.
            accountId: from.accountId
        } : null,
        // @ts-expect-error - TS2322 - Type '{ displayName: string | null; avatarUrl: string | undefined; accountId: string | undefined; } | null' is not assignable to type 'User | null'. | TS2532 - Object is possibly 'undefined'.
        toUser: !(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(to.displayValue) ? {
            // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
            displayName: to.displayValue,
            // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
            avatarUrl: to.avatarUrl,
            // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
            accountId: to.accountId
        } : null
    };
    if (fieldType === 'jira' && fieldId === 'status') return {
        fieldType: (0, $6s1PB.expVal)('issue_view_activity_timeline', 'isActivityTimelineEnabled', false) ? fieldType : undefined,
        type: (0, $905bb3e9efa8fc48$export$7566709b8f78aeb1),
        actor: actor,
        timestamp: timestamp,
        // @ts-expect-error - TS2322 - Type '{ name: string | null; statusCategory: StatusCategory; } | null' is not assignable to type 'Status | null'. | TS2533 - Object is possibly 'null' or 'undefined'.
        fromStatus: !(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(from.displayValue) ? {
            // @ts-expect-error - TS2533 - Object is possibly 'null' or 'undefined'.
            name: from.displayValue,
            // @ts-expect-error - TS2533 - Object is possibly 'null' or 'undefined'.
            statusCategory: (0, $gULOk.statusCategoryForId)(from.categoryId)
        } : null,
        // @ts-expect-error - TS2322 - Type '{ name: string | null; statusCategory: StatusCategory; } | null' is not assignable to type 'Status | null'. | TS2532 - Object is possibly 'undefined'.
        toStatus: !(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(to.displayValue) ? {
            // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
            name: to.displayValue,
            // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
            statusCategory: (0, $gULOk.statusCategoryForId)(to.categoryId)
        } : null
    };
    if (fieldType === 'jira' && fieldId === 'comment') return {
        fieldType: (0, $6s1PB.expVal)('issue_view_activity_timeline', 'isActivityTimelineEnabled', false) ? fieldType : undefined,
        type: (0, $905bb3e9efa8fc48$export$53e9822dbffbb9bc),
        actor: actor,
        timestamp: timestamp
    };
    if (fieldType === 'jira' && fieldId === 'softArchived') return {
        fieldType: (0, $6s1PB.expVal)('issue_view_activity_timeline', 'isActivityTimelineEnabled', false) ? fieldType : undefined,
        type: (0, $905bb3e9efa8fc48$export$5fd7b626c41a75e3),
        actor: actor,
        timestamp: timestamp,
        fromValue: from?.value
    };
    if (fieldType === 'jira' && fieldId === 'attachment') return {
        fieldType: (0, $6s1PB.expVal)('issue_view_activity_timeline', 'isActivityTimelineEnabled', false) ? fieldType : undefined,
        type: (0, $905bb3e9efa8fc48$export$107cfebb0511df9e),
        actor: actor,
        timestamp: timestamp,
        // @ts-expect-error - TS2533 - Object is possibly 'null' or 'undefined'. | TS2532 - Object is possibly 'undefined'.
        filename: from.displayValue ?? to.displayValue ?? '',
        // @ts-expect-error - TS2533 - Object is possibly 'null' or 'undefined'.
        action: !(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(from.displayValue) ? (0, $905bb3e9efa8fc48$export$4427798ee4002a4d) : (0, $905bb3e9efa8fc48$export$8648a9c7bbb05a59)
    };
    if (fieldType === 'jira' && fieldId === 'priority') return {
        fieldType: (0, $6s1PB.expVal)('issue_view_activity_timeline', 'isActivityTimelineEnabled', false) ? fieldType : undefined,
        type: (0, $905bb3e9efa8fc48$export$e0672bc3e33c4c82),
        actor: actor,
        timestamp: timestamp,
        fromPriority: {
            // @ts-expect-error - TS2533 - Object is possibly 'null' or 'undefined'.
            iconUrl: from.iconUrl || '',
            // @ts-expect-error - TS2533 - Object is possibly 'null' or 'undefined'.
            name: from.displayValue || ''
        },
        toPriority: {
            // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
            iconUrl: to.iconUrl || '',
            // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
            name: to.displayValue || ''
        }
    };
    // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
    if (fieldType === 'jira' && fieldDisplayName === 'WorklogId' && to.worklog) return {
        fieldType: (0, $6s1PB.expVal)('issue_view_activity_timeline', 'isActivityTimelineEnabled', false) ? fieldType : undefined,
        type: (0, $905bb3e9efa8fc48$export$33b21ab9c6fec8d0),
        actor: actor,
        timestamp: timestamp,
        // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
        comment: to.worklog.comment,
        // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
        timeSpent: to.worklog.timeSpent
    };
    if (fieldType === 'jira' && fieldDisplayName === 'IssueParentAssociation') return {
        fieldType: fieldType,
        type: (0, $905bb3e9efa8fc48$export$edaa98b0c4bb1ef3),
        actor: actor,
        timestamp: timestamp,
        // @ts-expect-error - TS2533 - Object is possibly 'null' or 'undefined'.
        fromValue: from.displayValue,
        // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
        toValue: to.displayValue
    };
    if (fieldType === 'jira' && (fieldId === 'timespent' || fieldId === 'timeestimate' || fieldId === 'timeoriginalestimate')) return {
        fieldType: (0, $6s1PB.expVal)('issue_view_activity_timeline', 'isActivityTimelineEnabled', false) ? fieldType : undefined,
        type: (0, $905bb3e9efa8fc48$export$37c97aab53f01e4c),
        actor: actor,
        field: fieldDisplayName,
        timestamp: timestamp,
        timeTrackingConfig: item.timeTrackingConfig ? item.timeTrackingConfig : null,
        // @ts-expect-error - TS2533 - Object is possibly 'null' or 'undefined'. | TS2345 - Argument of type 'string | null' is not assignable to parameter of type 'string'.
        fromTime: parseInt(from.value, 10),
        // @ts-expect-error - TS2532 - Object is possibly 'undefined'. | TS2345 - Argument of type 'string | null' is not assignable to parameter of type 'string'.
        toTime: parseInt(to.value, 10)
    };
    if (fieldType === 'custom' && fieldSchema && fieldSchema.customFieldType === 'com.atlassian.jira.plugin.system.customfieldtypes:float') return {
        fieldType: (0, $6s1PB.expVal)('issue_view_activity_timeline', 'isActivityTimelineEnabled', false) ? fieldType : undefined,
        type: (0, $905bb3e9efa8fc48$export$b45ef25f7a696e98),
        actor: actor,
        timestamp: timestamp,
        field: fieldDisplayName,
        // @ts-expect-error - TS2533 - Object is possibly 'null' or 'undefined'. | TS2533 - Object is possibly 'null' or 'undefined'.
        fromValue: !(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(from.displayValue) ? Number(from.displayValue) : null,
        // @ts-expect-error - TS2532 - Object is possibly 'undefined'. | TS2532 - Object is possibly 'undefined'.
        toValue: !(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(to.displayValue) ? Number(to.displayValue) : null
    };
    if ((fieldType === 'jira' || fieldType === 'custom') && fieldSchema && fieldSchema.type === 'date' || fieldType === 'custom' && fieldSchema && fieldSchema.type === 'datetime') // handles the default due date and custom date/datetime fields for the history log.
    return {
        fieldType: (0, $6s1PB.expVal)('issue_view_activity_timeline', 'isActivityTimelineEnabled', false) ? fieldType : undefined,
        type: (0, $905bb3e9efa8fc48$export$ccf54e923acb91b2),
        actor: actor,
        timestamp: timestamp,
        field: fieldDisplayName,
        // @ts-expect-error - TS2533 - Object is possibly 'null' or 'undefined'.
        fromDate: from.value,
        // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
        toDate: to.value,
        fieldSchema: fieldSchema.type
    };
    if (fieldType === 'custom' && fieldSchema?.customFieldType === (0, $5fc53.RESPONDERS_CF_TYPE)) return {
        fieldType: (0, $6s1PB.expVal)('issue_view_activity_timeline', 'isActivityTimelineEnabled', false) ? fieldType : undefined,
        type: (0, $905bb3e9efa8fc48$export$69a77f5e7c42a227),
        actor: actor,
        timestamp: timestamp,
        field: fieldDisplayName,
        // @ts-expect-error - TS2533 - Object is possibly 'null' or 'undefined'.
        fromValue: from.responders || null,
        // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
        toValue: to.responders || null
    };
    if (fieldType === 'custom' && fieldSchema?.customFieldType === (0, $5fc53.SERVICE_ENTITY_CF_TYPE)) return {
        fieldType: (0, $6s1PB.expVal)('issue_view_activity_timeline', 'isActivityTimelineEnabled', false) ? fieldType : undefined,
        type: (0, $905bb3e9efa8fc48$export$bf9ba14f4fe0e36a),
        actor: actor,
        timestamp: timestamp,
        field: fieldDisplayName,
        fromValue: from?.value || null,
        toValue: to?.value || null,
        fromDisplayValue: from?.displayValue || null,
        toDisplayValue: to?.displayValue || null
    };
    if (fieldType === 'jira' && fieldId === 'dataClassification') return {
        fieldType: (0, $6s1PB.expVal)('issue_view_activity_timeline', 'isActivityTimelineEnabled', false) ? fieldType : undefined,
        type: (0, $905bb3e9efa8fc48$export$844d56dab10d6cfb),
        actor: actor,
        timestamp: timestamp,
        field: fieldDisplayName,
        fromClassification: from?.displayValue ? {
            name: from?.displayValue,
            // @ts-expect-error - TS2533 - Object is possibly 'null' or 'undefined'.
            color: from?.color,
            // @ts-expect-error - TS2533 - Object is possibly 'null' or 'undefined'.
            guidelines: from?.guidelines
        } : null,
        toClassification: to?.displayValue ? {
            name: to?.displayValue,
            // @ts-expect-error - TS2533 - Object is possibly 'null' or 'undefined'.
            color: to?.color,
            // @ts-expect-error - TS2533 - Object is possibly 'null' or 'undefined'.
            guidelines: to?.guidelines
        } : null
    };
    return {
        fieldType: (0, $6s1PB.expVal)('issue_view_activity_timeline', 'isActivityTimelineEnabled', false) ? fieldType : undefined,
        type: (0, $905bb3e9efa8fc48$export$f567ac9d3526e5ce),
        actor: actor,
        timestamp: timestamp,
        field: fieldDisplayName,
        // @ts-expect-error - TS2533 - Object is possibly 'null' or 'undefined'.
        fromValue: from.displayValue,
        // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
        toValue: to.displayValue
    };
};
const $0f834988b4ac0bcf$export$5135eb3afa736a29 = ({ fields: { created: created, creator: creator } })=>({
        fieldType: 'jira',
        type: (0, $905bb3e9efa8fc48$export$91de1ada4d2d3ca6),
        actor: $0f834988b4ac0bcf$var$transformRestActor(creator),
        timestamp: (0, $eZDAP.default)(created)
    });
const $0f834988b4ac0bcf$export$716425a07890b235 = (data, maxResults)=>({
        nextPageStartIndex: data.viewIssue.history.isLast ? 0 : data.viewIssue.history.startIndex + maxResults,
        isLastPage: data.viewIssue.history.isLast,
        history: data.viewIssue.history.nodes.map($0f834988b4ac0bcf$export$a32d3e40a269588f)
    });

});
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $905bb3e9efa8fc48$var$HISTORY_GROUPED_ITEMS_CATEGORY = 'HISTORY';
const $905bb3e9efa8fc48$export$ed83fff9d5b2ca44 = 'REDACTION_GROUPED_HISTORY_ITEM';
const $905bb3e9efa8fc48$export$f1970b3f16b29de5 = 'ASSIGNEE_CHANGED';
const $905bb3e9efa8fc48$export$7566709b8f78aeb1 = 'STATUS_CHANGED';
const $905bb3e9efa8fc48$export$53e9822dbffbb9bc = 'COMMENT_CHANGED';
const $905bb3e9efa8fc48$export$5fd7b626c41a75e3 = 'ARCHIVED_CHANGED';
const $905bb3e9efa8fc48$export$107cfebb0511df9e = 'ATTACHMENT_CHANGED';
const $905bb3e9efa8fc48$export$e0672bc3e33c4c82 = 'PRIORITY_CHANGED';
const $905bb3e9efa8fc48$export$e5cb2c6d5fff1f58 = 'FLAG_CHANGED';
const $905bb3e9efa8fc48$export$f567ac9d3526e5ce = 'FIELD_CHANGED';
const $905bb3e9efa8fc48$export$b45ef25f7a696e98 = 'NUMERIC_FIELD_CHANGED';
const $905bb3e9efa8fc48$export$771d231cdd66c0e2 = 'RICH_TEXT_FIELD_CHANGED';
const $905bb3e9efa8fc48$export$91de1ada4d2d3ca6 = 'ISSUE_CREATED';
const $905bb3e9efa8fc48$export$33b21ab9c6fec8d0 = 'WORK_LOGGED';
const $905bb3e9efa8fc48$export$37c97aab53f01e4c = 'TIME_CHANGED';
const $905bb3e9efa8fc48$export$edaa98b0c4bb1ef3 = 'PARENT_ISSUE_CHANGED';
const $905bb3e9efa8fc48$export$ccf54e923acb91b2 = 'DATE_ISSUE_CHANGED';
const $905bb3e9efa8fc48$export$69a77f5e7c42a227 = 'RESPONDERS_CHANGED';
const $905bb3e9efa8fc48$export$bf9ba14f4fe0e36a = 'AFFECTED_SERVICES_CHANGED';
const $905bb3e9efa8fc48$export$33f8a9cb608132ba = 'Responders';
const $905bb3e9efa8fc48$export$5e56d79dfe9be3d = 'Affected services';
const $905bb3e9efa8fc48$export$a3171a3a7d9e1e5b = 'team';
const $905bb3e9efa8fc48$export$1187c3553ecd80a1 = 'user';
const $905bb3e9efa8fc48$export$844d56dab10d6cfb = 'DATA_CLASSIFICATION_CHANGED';
const $905bb3e9efa8fc48$export$53027079dd8d1476 = 'DATA_REDACTED';
const $905bb3e9efa8fc48$export$8648a9c7bbb05a59 = 'ATTACHMENT_UPLOADED';
const $905bb3e9efa8fc48$export$4427798ee4002a4d = 'ATTACHMENT_DELETED';
const $905bb3e9efa8fc48$export$75936e876282682b = 'FLAG_ADDED';
const $905bb3e9efa8fc48$export$cc84d15d1f34510d = 'FLAG_REMOVED';



parcelRegister("bm1Wv", function(module, exports) {

$parcel$export(module.exports, "groupHistoryItems", () => $4e399a60939fdb6d$export$5502f38a1909b15b);

var $7Jxgt = parcelRequire("7Jxgt");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

const $4e399a60939fdb6d$var$HISTORY_GROUPED_ITEMS_CATEGORY = 'HISTORY';
const $4e399a60939fdb6d$var$TIME_BATCH = 5;
const $4e399a60939fdb6d$var$isWithinTimeBatch = (item, lastItem)=>Math.abs(lastItem.timestamp.getTime() - item.timestamp.getTime()) / 60000 <= $4e399a60939fdb6d$var$TIME_BATCH;
const $4e399a60939fdb6d$var$isDescendingOrder = (firstItem, lastItem)=>firstItem.timestamp > lastItem.timestamp;
const $4e399a60939fdb6d$export$5502f38a1909b15b = (items)=>{
    if (!(0, $6s1PB.expVal)('issue_view_activity_timeline', 'isActivityTimelineEnabled', false)) return items;
    if (!items.length) return [];
    const itemsMap = new Map();
    const orderIsDescending = $4e399a60939fdb6d$var$isDescendingOrder(items[0], items[items.length - 1]);
    items.forEach((item)=>{
        if (item.type === (0, $905bb3e9efa8fc48$export$91de1ada4d2d3ca6)) {
            // we don't want to group this entry, so setting the item's id (not actor's id) as a key to disable potential further grouping
            itemsMap.set((0, $7Jxgt.v4)(), item);
            return;
        }
        const actor = item.actor;
        // Group redacted items separately, follow same grouping logic
        if (item.type === (0, $905bb3e9efa8fc48$export$53027079dd8d1476) && (0, $4R6GH.fg)('enable_redaction_support_in_jira_issue_view')) {
            // appending item type to differentiate redaction actors from other history items
            const currentItem = itemsMap.get(actor?.accountId + item.type);
            if (!currentItem) {
                if (actor?.accountId) itemsMap.set(actor.accountId + (0, $905bb3e9efa8fc48$export$53027079dd8d1476), item);
            } else {
                const isAlreadyGrouped = currentItem.type === (0, $905bb3e9efa8fc48$export$ed83fff9d5b2ca44);
                if ($4e399a60939fdb6d$var$isWithinTimeBatch(item, currentItem)) {
                    if (isAlreadyGrouped) currentItem.items.push(item);
                    else itemsMap.set(actor?.accountId + (0, $905bb3e9efa8fc48$export$53027079dd8d1476), {
                        type: (0, $905bb3e9efa8fc48$export$ed83fff9d5b2ca44),
                        timestamp: currentItem.timestamp,
                        actor: currentItem.actor,
                        items: [
                            currentItem,
                            item
                        ]
                    });
                } else {
                    // don't need to be grouped, so setting the random id as a key to disable potential further grouping
                    itemsMap.set((0, $7Jxgt.v4)(), currentItem);
                    itemsMap.set(actor?.accountId + (0, $905bb3e9efa8fc48$export$53027079dd8d1476), item);
                }
            }
            return;
        }
        const currentItem = itemsMap.get(actor?.accountId);
        if (!currentItem) {
            if (actor?.accountId) itemsMap.set(actor.accountId, item);
        } else {
            const isAlreadyGrouped = currentItem.type === $4e399a60939fdb6d$var$HISTORY_GROUPED_ITEMS_CATEGORY;
            if ($4e399a60939fdb6d$var$isWithinTimeBatch(item, currentItem)) {
                if (isAlreadyGrouped) currentItem.items.push(item);
                else itemsMap.set(actor?.accountId, {
                    type: $4e399a60939fdb6d$var$HISTORY_GROUPED_ITEMS_CATEGORY,
                    timestamp: currentItem.timestamp,
                    actor: currentItem.actor,
                    items: [
                        currentItem,
                        item
                    ]
                });
            } else {
                // don't need to be grouped, so setting the random id as a key to disable potential further grouping
                itemsMap.set((0, $7Jxgt.v4)(), currentItem);
                itemsMap.set(actor?.accountId, item);
            }
        }
    });
    const sortedByTimeItems = Array.from(itemsMap.values()).sort((a, b)=>{
        if (orderIsDescending) return b.timestamp.getTime() - a.timestamp.getTime();
        return a.timestamp.getTime() - b.timestamp.getTime();
    });
    return sortedByTimeItems;
};

});


parcelRegister("ir3sd", function(module, exports) {

$parcel$export(module.exports, "default", () => $485dea64c24eaa99$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $6s1PB = parcelRequire("6s1PB");

var $aWse0 = parcelRequire("aWse0");


var $aRnnp = parcelRequire("aRnnp");

var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");
var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $70ZWV = parcelRequire("70ZWV");

var $4FhE5 = parcelRequire("4FhE5");
const $485dea64c24eaa99$var$HISTORY_GROUPED_ITEMS_CATEGORY = 'HISTORY';
const $485dea64c24eaa99$export$1b027679229955ad = ({ formatMessage: formatMessage, isLoadingMore: isLoadingMore, onLoadMore: onLoadMore, sortOrder: sortOrder })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const prevIsLoadingMore = (0, $5uXOq.useRef)(isLoadingMore);
    (0, $5uXOq.useEffect)(()=>{
        prevIsLoadingMore.current = isLoadingMore;
    }, [
        isLoadingMore
    ]);
    const onLoadMoreButtonClick = ()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        });
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'loadMoreButtonClicked', {
            loadMoreButtonTypeClicked: sortOrder === (0, $c97bf8752afb1bcb$export$eda5fe8da1abb04c) ? 'LOAD_OLDER_BUTTON' : 'LOAD_NEWER_BUTTON'
        });
        onLoadMore();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aRnnp.default), {
        shouldFitContainer: true,
        isDisabled: isLoadingMore,
        isLoading: isLoadingMore,
        onClick: onLoadMoreButtonClick
    }, formatMessage((0, $4FhE5.default).loadMore));
};
const $485dea64c24eaa99$var$HistoryItems = ({ history: history, isLoadingMore: isLoadingMore, onLoadMore: onLoadMore, hasMore: hasMore, sortOrder: sortOrder, GroupedActivityEntryComponent: GroupedActivityEntry })=>{
    const intl = (0, $aWse0.useIntlV2)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: "historyItems",
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a)
    }, history.map((historyItem, index)=>{
        const isGroupedActivityEntryEnrolledInIssueViewActivityTimelineExperiment = // eslint-disable-next-line jira/ff/no-preconditioning
        (0, $6s1PB.expVal)('issue_view_activity_timeline', 'isActivityTimelineEnabled', false) && historyItem?.type === $485dea64c24eaa99$var$HISTORY_GROUPED_ITEMS_CATEGORY && GroupedActivityEntry;
        if (isGroupedActivityEntryEnrolledInIssueViewActivityTimelineExperiment) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(GroupedActivityEntry, {
            key: index,
            item: historyItem
        });
        if ((0, $6s1PB.expVal)('issue_view_activity_timeline', 'isActivityTimelineEnabled', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, {
            key: index
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $70ZWV.default), {
            historyItem: historyItem
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $485dea64c24eaa99$var$horizontalDividerStyles
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $70ZWV.default), {
            key: index,
            historyItem: historyItem
        });
    }), hasMore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-testid": "issue-history.ui.history-items.load-more-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($485dea64c24eaa99$export$1b027679229955ad, {
        formatMessage: intl.formatMessage,
        isLoadingMore: isLoadingMore,
        onLoadMore: onLoadMore,
        sortOrder: sortOrder
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), null));
};
const $485dea64c24eaa99$var$horizontalDividerStyles = (0, $8CUq3.xcss)({
    height: '1px',
    width: '100%',
    backgroundColor: 'color.background.neutral',
    marginTop: 'space.200'
});
var $485dea64c24eaa99$export$2e2bcd8739ae039 = $485dea64c24eaa99$var$HistoryItems;

});
parcelRegister("aRnnp", function(module, exports) {

$parcel$export(module.exports, "default", () => $e093d68a7aff8b34$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $eZJjh = parcelRequire("eZJjh");
// Mimics the new `isLoading` prop in @atlaskit/button@7.x. This component can
// be deleted when we upgrade to the latest version of @atlaskit/button.
const $e093d68a7aff8b34$var$Button = (props)=>{
    const { children: children, isDisabled: isDisabled, isLoading: isLoading, onClick: onClick, shouldFitContainer: shouldFitContainer } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        onClick: onClick,
        isDisabled: isDisabled,
        // @ts-expect-error - TS2322 - Type 'Element | null' is not assignable to type 'ReactChild | undefined'.
        iconAfter: isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
            size: "small"
        }) : null,
        shouldFitContainer: shouldFitContainer
    }, !isLoading ? children : null);
};
var $e093d68a7aff8b34$export$2e2bcd8739ae039 = $e093d68a7aff8b34$var$Button;

});

// SCREENS
const $4d5e0871c06cee03$export$f636b5b56f1d624a = 'Screen';
const $4d5e0871c06cee03$export$9d2de6eebf7462b5 = 'Drawer';
const $4d5e0871c06cee03$export$1171103ea9083ffa = 'Modal';
const $4d5e0871c06cee03$export$cae2783c9279926 = 'InlineDialog';
const $4d5e0871c06cee03$export$d1123261ca8831d2 = 'Dropdown';
const $4d5e0871c06cee03$export$238d30785c4bca84 = 'Banner';
const $4d5e0871c06cee03$export$a1562d08625f5d7e = 'UI';
const $4d5e0871c06cee03$export$947dac6c72b26f81 = 'TRACK';
const $4d5e0871c06cee03$export$f1d537d508d2945a = 'SCREEN';
const $4d5e0871c06cee03$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("4FhE5", function(module, exports) {

$parcel$export(module.exports, "default", () => $736ac7b6cdbb90f1$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $736ac7b6cdbb90f1$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    loadMore: {
        "id": "issue-history.history-items.load-more",
        "defaultMessage": "Load more"
    }
});

});





//# sourceMappingURL=async-activity-feed-item-history.34623e2d.js.map
